import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { DisplayMode, EnrichedRecommendationItem, SaveToListItem } from '../../../lib/types';

/**
 * If owner type is USER - the resourceId is the userId (fetched from contexto), otherwise it's the business id
 */
export interface SaveItemsToListRequest {
    name: string;
    description?: string;
    ownerType: 'USER' | 'BUSINESS';
    businessId?: string;
    items: EnrichedRecommendationItem[];
    displayMode: DisplayMode;
}

const mapItems = (items: EnrichedRecommendationItem[], displayMode): SaveToListItem[] =>
    items.map((item) => {
        const resource_id = displayMode === DisplayMode.Sellers ? item.gigs?.[0]?.id : item.gig_id;

        return {
            resource_id,
            resource_type: !resource_id && displayMode === DisplayMode.Sellers ? 'SELLER' : 'GIG',
        };
    });

export const saveItemsToList = async ({ items, displayMode, ...params }: SaveItemsToListRequest) => {
    try {
        await axios.post('/support/api/recommendations', {
            items: mapItems(items, displayMode),
            ...params,
        });
    } catch (error) {
        logger.error('Failed to save items to list', { error });
        throw error;
    }
};
